/** MUTATIONS */
import { gql } from '@apollo/client';

/** mutation to upsert rule in data quality */
export const UPSERT_RULE = gql`
mutation DQupsertRule($dimensionId:Int, $filterExpression:String, $filterTypeId:Int,
	$projectId:Int, $ruleDescription:String, $ruleId:Int, $ruleName:String) {
	DQupsertRule(dimensionId:$dimensionId, filterExpression:$filterExpression,
		filterTypeId:$filterTypeId, projectId:$projectId, ruleDescription:$ruleDescription, ruleId:$ruleId, ruleName:$ruleName)
	{
		rule{
			ruleId
		}
	}
}`;

/** mutation to assign new rules in data quality */
export const ASSIGN_RULES = gql`
mutation DQassignRules($assignedRules:[RuleMappingInput], $fileName:String) {
	DQassignRules(assignedRules:$assignedRules,fileName:$fileName) {
		assignedRule{
			fileName
			assignedRules
		}
	}
}`;
